import { ChangeEvent } from 'react';

export const modifyEvent = (
  e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  regex: RegExp,
) => {
  const { value } = e.target;

  if (!regex.test(value)) {
    e.target.value = value.slice(0, -1);
  }

  return e;
};
